// Verwaltung (nur GQL): Lieferungen prüfen, freigeben, nachfordern oder ablehnen; JurNodes-Stand.
import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import type { DbPortalLieferung } from '@gql/shared-types';
import { useAuth } from '../auth/AuthKontext.js';
import { Entscheidung, LieferungKarte, useLieferungen } from '../components/Lieferungen.js';
import { VerwaltungReiter } from '../components/VerwaltungReiter.js';
import { LIEFER_STATUS_TEXT } from '../daten/lieferungen.js';

const FILTER: Array<DbPortalLieferung['status'] | 'alle'> = ['offen', 'nachforderung', 'freigegeben', 'abgelehnt', 'alle'];

export function VerwaltungLieferungen() {
  const { zustand } = useAuth();
  const admin = zustand.status === 'bereit' && zustand.ich.nutzer?.rolle === 'gql_admin';
  const [status, setStatus] = useState<(typeof FILTER)[number]>('offen');
  const [neu, setNeu] = useState(0);
  const { liste, fehler } = useLieferungen(`/admin/lieferungen?status=${status}`, neu);
  if (!admin) return <Navigate to="/standorte" replace />;
  return (
    <div className="seite">
      <h1>Lieferungen</h1>
      <VerwaltungReiter />
      <div className="reiter" role="tablist" aria-label="Status">
        {FILTER.map((f) => (
          <button key={f} type="button" role="tab" aria-selected={status === f} className={status === f ? 'reiter-aktiv' : ''} onClick={() => setStatus(f)}>
            {f === 'alle' ? 'Alle' : LIEFER_STATUS_TEXT[f]}
          </button>
        ))}
      </div>
      {fehler && (
        <p className="fehlertext" role="alert">
          {fehler}
        </p>
      )}
      {liste && !liste.lieferungen.length && <p className="zelle-hinweis">Keine Lieferungen in dieser Ansicht.</p>}
      <div className="lieferungen">
        {liste?.lieferungen.map((l) => (
          <LieferungKarte key={l.id} l={l} mitStandort kinder={<Entscheidung l={l} nachher={() => setNeu((n) => n + 1)} />} />
        ))}
      </div>
    </div>
  );
}
